var consts = {
    MainUrl: "https://backend.crymadx.io/",
    BackendUrl: "https://backend.crymadx.io/crymadx",
    FrondEndUrl: "https://www.crymadx.io",
    socketUrl: 'https://backend.crymadx.io',

    MainPair: "BTC_USDC",

    // MainUrl: "http://localhost:3500",
    // BackendUrl: "http://localhost:3500/crymadx",
    // socketUrl: 'http://localhost:3500',
    // FrondEndUrl: "http://localhost:5173",

    //  BINANCE WEBSOCKET   
    BinanceSocket: "wss://stream.binance.com:9443/ws/!ticker@arr",

    VITE_HCAPTCHA_SITEKEY: "6LeujYcrAAAAABxm8AYf9T5sQ7HAupWcVCRzP9Qn",
    VITE_RECAPTCHA_SITEKEY: "6LeujYcrAAAAABxm8AYf9T5sQ7HAupWcVCRzP9Qn",   // live key 

}
export default consts;
